import React from 'react';
import { Text, TextProps } from 'react-native';

/**
 * Shared text style components for consistent typography across the app
 * These components include proper line heights to prevent text clipping
 */

interface StyledTextProps extends TextProps {
	children: React.ReactNode;
}

// Large heading text (24px) - for main titles
export const HeadingText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 24, fontWeight: '700', lineHeight: 28, color: '#333333' }, style]} {...props} />
);

// Medium heading text (20px) - for section titles
export const SubheadingText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 20, fontWeight: '700', lineHeight: 24, color: '#333333' }, style]} {...props} />
);

// Body text (16px) - for regular content
export const BodyText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 16, fontWeight: '400', lineHeight: 20, color: '#333333' }, style]} {...props} />
);

// Small text (14px) - for descriptions
export const SmallText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 14, fontWeight: '400', lineHeight: 18, color: '#333333' }, style]} {...props} />
);

// Caption text (12px) - for metadata
export const CaptionText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 12, fontWeight: '400', lineHeight: 16, color: '#666666' }, style]} {...props} />
);

// Bold body text (16px bold) - for emphasized content
export const BoldBodyText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 16, fontWeight: '700', lineHeight: 20, color: '#333333' }, style]} {...props} />
);

// Bold small text (14px bold) - for emphasized descriptions
export const BoldSmallText: React.FC<StyledTextProps> = ({ style, ...props }) => (
	<Text style={[{ fontSize: 14, fontWeight: '700', lineHeight: 18, color: '#333333' }, style]} {...props} />
);
